if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      static countryLanguages = {"CZ":"cs","SK":"sk","DE":"de","AT":"de","CH":"de|fr|it","LI":"de","FR":"fr","LU":"fr|de","MC":"fr","BE":"nl|fr|de","SN":"fr","CI":"fr","CM":"fr","MG":"fr","ML":"fr","BF":"fr","NE":"fr","TG":"fr","BJ":"fr","GA":"fr","CG":"fr","CD":"fr","GN":"fr","HT":"fr","RE":"fr","GP":"fr","MQ":"fr","GF":"fr","YT":"fr","PF":"fr","NC":"fr","PM":"fr","BL":"fr","MF":"fr","WF":"fr","TN":"fr","MA":"fr","DZ":"fr","ES":"es","MX":"es","AR":"es","CO":"es","PE":"es","VE":"es","CL":"es","EC":"es","GT":"es","CU":"es","BO":"es","DO":"es","HN":"es","PY":"es","SV":"es","NI":"es","CR":"es","PA":"es","UY":"es","PR":"es","GQ":"es","IT":"it","SM":"it","VA":"it","PL":"pl","NL":"nl","SR":"nl","AW":"nl","CW":"nl","SX":"nl","BQ":"nl","PT":"pt-PT|pt-BR","AO":"pt-PT|pt-BR","MZ":"pt-PT|pt-BR","CV":"pt-PT|pt-BR","GW":"pt-PT|pt-BR","ST":"pt-PT|pt-BR","TL":"pt-PT|pt-BR","BR":"pt-BR|pt-PT","SE":"sv","AX":"sv","DK":"da","GL":"da","FO":"da","FI":"fi","NO":"nb","SJ":"nb","HU":"hu","RO":"ro","MD":"ro","GR":"el","CY":"el","HR":"hr","BA":"hr","BG":"bg","SI":"sl","LT":"lt","BY":"ru","KZ":"ru","KG":"ru","TR":"tr","JP":"ja","KR":"ko","CN":"zh-CN","SG":"zh-CN","TW":"zh-TW","HK":"zh-TW","MO":"zh-TW","TH":"th","VN":"vi","ID":"id"};

      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
        };
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.addEventListener('focusout', this.closeSelector.bind(this));
        this.elements.button.addEventListener('click', this.openSelector.bind(this));

        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
        }

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }
        document.body.classList.remove('overflow-hidden-mobile');
        document.querySelector('.menu-drawer').classList.remove('country-selector-open');
        this.header.preventHide = false;
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
          } else {
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
        });
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case 'SPACE':
            if (this.elements.button.getAttribute('aria-expanded') == 'true') return;
            this.openSelector();
            break;
        }
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        this.syncLocale(event.currentTarget.dataset.value);
        this.rememberChoice();
        if (form) form.submit();
      }

      // Remember a manual choice so the automatic language detection never overrides it.
      rememberChoice() {
        const form = this.querySelector('form');
        if (!form) return;
        const lang = form.querySelector('input[name="locale_code"]:not([disabled])');
        const country = form.querySelector('input[name="country_code"]');
        const html = document.documentElement;
        try {
          localStorage.setItem('glow-geo', ['manual', lang ? lang.value : html.dataset.glowLocale || '', country ? country.value : html.dataset.glowCountry || ''].join(':'));
        } catch (e) {}
      }

      // Picking a country also switches the storefront to that country's language
      // (falls back to the primary language when it isn't published).
      syncLocale(country) {
        const input = this.querySelector('input[data-glow-auto-locale]');
        if (!input || !country) return;
        const available = input.dataset.available.split(',');
        const candidates = (LocalizationForm.countryLanguages[country.toUpperCase()] || '').split('|').filter(Boolean);
        const match = candidates
          .map((code) => available.find((lang) => lang.toLowerCase() === code.toLowerCase()) ||
            available.find((lang) => lang.split('-')[0].toLowerCase() === code.split('-')[0].toLowerCase()))
          .find(Boolean);
        input.value = match || input.dataset.primary;
        input.disabled = false;
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
        if (!document.body.classList.contains('overflow-hidden-tablet')) {
          document.body.classList.add('overflow-hidden-mobile');
        }
        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }
        if (this.hasAttribute('data-prevent-hide')) {
          this.header.preventHide = true;
        }
        document.querySelector('.menu-drawer').classList.add('country-selector-open');
      }

      closeSelector(event) {
        if (
          event.target.classList.contains('country-selector__overlay') ||
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          this.hidePanel();
        }
      }

      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      }

      filterCountries() {
        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a');
        let visibleCountries = allCountries.length;

        this.elements.resetButton.classList.toggle('hidden', !searchValue);

        if (popularCountries) {
          popularCountries.classList.toggle('hidden', searchValue);
        }

        allCountries.forEach((item) => {
          const countryName = this.normalizeString(item.querySelector('.country').textContent);
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove('hidden');
            visibleCountries++;
          } else {
            item.parentElement.classList.add('hidden');
            visibleCountries--;
          }
        });

        if (this.elements.liveRegion) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
            '[count]',
            visibleCountries
          );
        }

        this.querySelector('.country-selector').scrollTop = 0;
        this.querySelector('.country-selector__list').scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
      }

      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }
    }
  );
}
